import * as React from 'react';
import { connect } from 'react-redux';

import {
  CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER,
  ENTITIES_PER_PAGE
} from 'modules/create-new-profiles/constants/common';
import { getValidationErrorsForEntities } from 'modules/create-new-profiles/utils/entities';

import { __t, applyTranslations } from 'utils/language';

import './create-new-profiles-entities-list-errors.scss';
import { State } from 'types';

applyTranslations(require('./create-new-profiles-entities-list-errors.i18n.json'));

interface Props {
  errors: Array<String>
}

const CreateNewProfilesEntitiesListErrors = ({
  errors
}: Props): JSX.Element => (
  <div className="create-new-profiles-entities-list-errors">
    {errors.map((error, index) => (
      <span
        key={index}
        className="create-new-profiles-entities-list-errors__line"
      >
        {error}
      </span>
    ))}
  </div>
);

const mapStateToProps = ({ createNewProfiles }: State): Props => {
  const { createEntitiesModal } = createNewProfiles;
  const errorTexts = {
    email: __t('create_new_profiles_entities_list_errors.email'),
    name: __t('create_new_profiles_entities_list_errors.name'),
    urls: __t('create_new_profiles_entities_list_errors.urls'),
    urlLength: __t('create_new_profiles_entities_list_errors.urlLength'),
    separator: __t('create_new_profiles_entities_list_errors.separator')
  };

  if (createEntitiesModal.type === CREATE_NEW_PROFILES_MODAL_MANUAL_IDENTIFIER) {
    return {
      errors: getValidationErrorsForEntities(
        createEntitiesModal.entities,
        createEntitiesModal.page,
        ENTITIES_PER_PAGE,
        errorTexts
      )
    };
  }

  if (createEntitiesModal.data?.type === 'successful-upload') {
    return {
      errors: getValidationErrorsForEntities(
        createEntitiesModal.data.entities,
        createEntitiesModal.data.page,
        ENTITIES_PER_PAGE,
        errorTexts
      )
    };
  }

  return {
    errors: []
  };
};

export default connect(mapStateToProps)(CreateNewProfilesEntitiesListErrors);
